import React from 'react';
import jQuery from 'jquery'
import Configurator from './Configurator.jsx';
import styles from './PowerSwitcherConfigurator.styl';
import Image from './ui/features/Image.jsx';
import Table from './ui/features/Table.jsx';
import Button from './ui/button/Button.jsx'
import MultiSelect from './ui/features/MultiSelect.js';


const acbInputDefault ={
	filterToolType:'Выбрать',
	filterPolNumb:'Выбрать',
	filterPerformance:'Выбрать',
	filterIN:'Выбрать',
	filterICU:'Выбрать',
	filterSize:'Выбрать',
	filterUnHook:[],
	eui:false,
}

const mccbInputDefault = {
	filterMccbPolNumb:'Выбрать',
	filterMccbIN:'Выбрать',
	filterMccbICU:'Выбрать',
	filterMccbSize:'Выбрать',
	filterMccbUnHook:'Выбрать',
}

const addInputDefault = {
	filterAddDisplay:'Выбрать',
	filterAddProtect:'Выбрать',
	modBus:false,
	changeFunc:false
}

class PowerSwitcherConfigurator extends Configurator {


	//Конструктор
	constructor(props) {
		super(props);
		this.state={


			//Списки
			itemList: [], 										// Подобранные аксессуары
			specList: [], 										// Спецификация оборудования
			acbList: [], 											// Список выключателей acb
			mccbList: [], 										// Список выключателей mccb

			summ: 0,

			//Тип Таба
			tabType:"acb",

			//Высота таблицы
			tableHeight: '320px',
			tableTop: '430px',
			bgHeight: '255px',

			toolTypeOptions:[],
			polNumbOptions:[],
			performanceOptions:[],
			iNOptions:[],
			iCUOptions:[],
			sizeOptions:[],
			unHookOptions:[],

			mccbPolNumbOptions:[],
			mccbINOptions:[],
			mccbICUOptions:[],
			mccbSizeOptions:[],
			mccbUnHookOptions:[],

			addDisplayOptions:[],
			addProtectOptions:[],

			...acbInputDefault,
			...mccbInputDefault,
			...addInputDefault,
		}

		// Обработка событий таблиц
		this.onChangeQuantity 							= this.onChangeQuantity.bind(this);
		this.addBasket 											= this.addBasket.bind(this);
		this.onDelete 											= this.onDelete.bind(this);

		//Кнопки
		this.doPrint 												= this.doPrint.bind(this);
		this.onBtnExcelClick 								= this.onBtnExcelClick.bind(this);
		this.onBtnArrayClick 								= this.onBtnArrayClick.bind(this);
		this.onBtnStepClick 								= this.onBtnStepClick.bind(this);
		this.onBtnDWGClick 									= this.onBtnDWGClick.bind(this);
		this.onClearFiltersClick 						= this.onClearFiltersClick.bind(this);

		//Служебные процедуры
		this.getItemList 										= this.getItemList.bind(this);
		this.getOptions 										= this.getOptions.bind(this);

		this.onFilterChange									= this.onFilterChange.bind(this);

		this.acbChosen 											= this.acbChosen.bind(this);
		this.mccbChosen 										= this.mccbChosen.bind(this);
		this.clearAcb 											= this.clearAcb.bind(this);
		this.clearMccb											= this.clearMccb.bind(this);

		this.acbDropDown 										= this.acbDropDown.bind(this);
		this.mccbDropDown 									= this.mccbDropDown.bind(this);
		this.euiDropDown 										= this.euiDropDown.bind(this);
		this.euiCheckBox 										= this.euiCheckBox.bind(this);

		this.onToolTypeChange 							= this.onToolTypeChange.bind(this);
		this.onPolNumbChange 								= this.onPolNumbChange.bind(this);
		this.onPerformanceChange 						= this.onPerformanceChange.bind(this);
		this.onINChange 										= this.onINChange.bind(this);
		this.onICUChange 										= this.onICUChange.bind(this);
		this.onSizeChange 									= this.onSizeChange.bind(this);
		this.onUnHookChange 								= this.onUnHookChange.bind(this);

		this.onMccbPolNumbChange 						= this.onMccbPolNumbChange.bind(this);
		this.onMccbINChange 								= this.onMccbINChange.bind(this);
		this.onMccbICUChange 								= this.onMccbICUChange.bind(this);
		this.onMccbSizeChange 							= this.onMccbSizeChange.bind(this);
		this.onMccbUnHookChange 						= this.onMccbUnHookChange.bind(this);

		this.onAddDisplayChange 						= this.onAddDisplayChange.bind(this);
		this.onAddProtectChange 						= this.onAddProtectChange.bind(this);

		this.getFilteredAcbArray 						= this.getFilteredAcbArray.bind(this);
		this.getFilteredMccbArray 					= this.getFilteredMccbArray.bind(this);

		this.changeAcbFilterOptions 				= this.changeAcbFilterOptions.bind(this);
		this.changeMccbFilterOptions 				= this.changeMccbFilterOptions.bind(this);

		this.addInfo 												= this.addInfo.bind(this);
		this.onEuiChange 										= this.onEuiChange.bind(this);

		this.onModBusChange 								= this.onModBusChange.bind(this);
		this.onChangeFuncChange 						= this.onChangeFuncChange.bind(this);

		this.addCurrent 										= this.addCurrent.bind(this);

		this.onUnHookDelete 								= this.onUnHookDelete.bind(this);
		this.onMccbUnHookDelete 						= this.onMccbUnHookDelete.bind(this);

		this.onCheckBoxChange 							= this.onCheckBoxChange.bind(this);
		this.onDDChange 										= this.onDDChange.bind(this);

	}

	loadDb() {
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'get'
			},
			db => {
				this.db = db;
				this.getItemList()
			}
		);
	}

	// ++ Для Запуска
	getCustomStyles() {
		return styles;
	}

	getType() {
		return 'power';
	}
	// -- Для Запуска


	// ++ Служебные процедуры и функции
	getItemList(){
		const newArr = this.db.list.reduce((counter, item) =>{
			if(item.type === 'acb') 							counter.acbList.push(item)
			if(item.type === 'mccb') 							counter.mccbList.push(item)
			return counter
		},{
			acbList:[],
			mccbList:[],
		})
		this.setState({
			itemList: newArr.acbList,
			acbList:newArr.acbList,
			mccbList:newArr.mccbList,
		}, ()=>{
			this.changeAcbFilterOptions(this.state.acbList)
		})
	}

	getOptions(array, param){
		let result = this.delDuplicatesFromArray(array.map(item => {
			if(item[param] !== '0') return item[param]
			return null
		}))
		result = result.filter(Boolean)
		result.unshift('Выбрать')
		return result
	}
	// -- Служебные процедуры и функции


	// ++Кнопки
	getCustomButtons() {
		let elements = [];

		elements.push(
			<Button
				x="594"
				y="764"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Скачать DWG"
				onClick={this.onBtnDWGClick}
				key="DWG"
			/>
		);

		elements.push(
			<Button
				x="794"
				y="764"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Скачать STEP-модели"
				onClick={this.onBtnStepClick}
				key="step"
			/>
		);

		elements.push(
			<Button
				x="994"
				y="764"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Сохранить в PDF"
				onClick={this.onBtnPrintPdfClick}
				key="printpdf"
			/>
		);

		elements.push(
			<Button
				x="1194"
				y="709"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.printBtnIcon}
				text="Распечатать"
				onClick={this.onBtnPrintClick}
				key="print"
			/>
		);

		elements.push(
			<Button
				x="1194"
				y="764"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.excelBtnIcon}
				text="Сохранить в Excel"
				onClick={this.onBtnExcelClick}
				key="excel"
			/>
		);

		return elements;
	}
	//-- Кнопки


	// ++ Обработка печати
	doPrint(params) {
		let _params = params || {};
		_params.data = {
			specList: JSON.stringify(this.state.specList)
		};
		super.doPrint(_params);
	}

	onBtnExcelClick() {
		this.doPrint({format: 'xls'});
	}
	// -- Обработка печати


	onBtnArrayClick(fileName){
		window.location = `itkcfg.php?type=${this.getType()}&action=getFile&name=${fileName}.zip`;
	}

	onBtnDWGClick(){
		this.onBtnArrayClick('DWG');
	}
	onClearFiltersClick(){
		this.state.tabType === 'acb' ? this.clearAcb() :	this.clearMccb()
	}

	onBtnStepClick(){
		this.onBtnArrayClick('step');
	}

	// ++ Работа таблиц
	//Отображение выбранного значения
	onListItemCheck(item) {
		super.onListItemCheck(item.article)
	}

	// Добавить элемент в корзину
	addBasket(item) {

		this.setState(prevState => {
			const specList = [...prevState.specList]
			if (specList.some(i => i.article === item.article)) {
				specList.map(i => {
					if(i.article === item.article) {
						i.count = Number(i.count) + 1
						// i.sum = (i.price*i.count).toFixed(2)
					}
					return i
				})
			} else {
				item.count = 1
				// item.sum = (item.count*price).toFixed(2)
				// item = {...item, 'price': price}
				specList.push(item)
			}
			let summ = 0
			// let summ = specList.map(item => item.price*item.count).reduce((previousValue, currentValue) => {
			// 	return previousValue + currentValue
			// }).toFixed(2)
			return {specList, summ}
		},()=>{
			this.doAddToCart(this.state.specList)
		})


		// jQuery.getJSON(
		// 	'itkcfg.php',
		// 	{
		// 		type: this.getType(),
		// 		action: 'getItemPriceNSI',
		// 		article: item.article,
		// 		groupId: '20.02.0'
		// 	},	result => {
		// 		let price = result[0].price
		//
		// 	})
	}

	//Удаление
	onDelete(item) {

		this.setState((prevState) => {
			return {
				...prevState,
				specList: prevState.specList.filter((el) => el.article !== item.article)
			}
		}, ()=>{
			// let specList = this.state.specList
			let summ = 0
			// if(specList.length){
			// 	summ= specList.map(item => item.price).reduce((previousValue, currentValue) => {
			// 		return previousValue + currentValue
			// 	}).toFixed(2)
			// }
			this.setState({summ})
			this.doAddToCart(this.state.specList)
		})

	}

	// изменение количества позиции
	onChangeQuantity(item, value) {

		this.setState(prevState => {
			const newBasket = prevState.specList.map(i => {
				if (i.article === item.article) {
					i.count = value
					// i.sum = (value*item.price).toFixed(2)
				}
				return i
			})
			let summ = 0
			// 	prevState.specList.map(item => item.price*item.count).reduce((previousValue, currentValue) => {
			// 	return previousValue + currentValue
			// }).toFixed(2)
			return {
				specList: newBasket,
				summ
			}
		},()=>{
			this.doAddToCart(this.state.specList)
		})
	}
	// -- Работа таблиц


	// ++ Обработка выбора таба
	acbChosen(){
		if(this.state.tabType === 'acb') 	return
		this.clearAcb()
	}

	clearAcb(){
		this.changeAcbFilterOptions(this.state.acbList)
		this.setState({
			tabType: 'acb',
			tableHeight: '320px',
			tableTop: '430px',
			bgHeight: '255px',
			itemList:this.state.acbList,
			...acbInputDefault,
			...addInputDefault,
		})
	}



	mccbChosen(){
		if(this.state.tabType === 'mccb') return
		this.clearMccb()
	}

	clearMccb(){
		this.changeMccbFilterOptions(this.state.mccbList)
		this.setState({
			tabType: 'mccb',
			tableHeight: '415px',
			tableTop: '350px',
			bgHeight: '175px',
			itemList:this.state.mccbList,
			...mccbInputDefault,
		})
	}


// -- Обработка выбора таба

// ++ Дропдауны
	acbDropDown(){
		let elements = [];
		elements.push(<DropDown type='toolType' x={40} y={170} title='Тип изделия:' key={'acb'+1} app={this}/> )
		elements.push(<DropDown type='polNumb' x={40} y={220} title='Количество полюсов:' key={'acb'+2} app={this}/> )
		elements.push(<DropDown type='iCU' x={40} y={270} title='Отключающая способность (Icu), кA:' key={'acb'+3} app={this}/> )

		elements.push(<MultiSelect
			label="Тип расцепителя:"
			placeholder="Выбрать"
			key={'acb'+4}
			options={this.state.unHookOptions}
			multiple
			background="#f0f0f0"
			color='#3c4e50'
			values={this.state.filterUnHook}
			style={{top:'320px',left:'38px'}}
			onChange={this.onUnHookChange}
			onDelete={this.onUnHookDelete}
		/>)

		elements.push(<DropDown type='performance' x={280} y={170} title='Исполнение:' key={'acb'+5} app={this}/> )
		elements.push(<DropDown type='iN' x={280} y={220} title='Номинальный ток (In), А:' key={'acb'+6} app={this}/> )
		elements.push(<DropDown type='size' x={280} y={270} title='Типоразмер:' key={'acb'+7} app={this}/> )
		return elements
	}

	mccbDropDown() {
		let elements = [];

		elements.push(<DropDown type='mccbUnHook' x={40} y={170} title='Тип расцепителя:' key={'mccb'+elements.length} app={this}/> )
		elements.push(<DropDown type='mccbIN' x={280} y={220} title='Номинальный ток (In), А:' key={'mccb'+elements.length} app={this}/> )
		elements.push(<DropDown type='mccbSize' x={40} y={270} title='Типоразмер, In, A:' key={'mccb'+elements.length} app={this}/> )
		elements.push(<DropDown type='mccbPolNumb' x={280} y={170} title='Количество полюсов:' key={'mccb'+elements.length} app={this}/> )
		elements.push(<DropDown type='mccbICU' x={40} y={220} title='Отключающая способность (Icu), кA:' key={'mccb'+elements.length} app={this}/> )

		return elements
	}

	euiDropDown(){
		let elements = [];
		elements.push(<DropDown type='addDisplay' x={40} y={400} title='Тип дисплея:' key={'add'+elements.length} app={this}/> )
		elements.push(<DropDown type='addProtect' x={280} y={400} title='Тип защиты:' key={'add'+elements.length} app={this}/> )
		return elements
	}

// -- Дропдауны

	// ++ ЧекБоксы

	euiCheckBox(){
		let elements = [];
		elements.push(<CheckBoxWithTitle type='changeFunc' x={165} lableX={40} y={455} lableY={457} widthLbl={130} title='Функция "Измерения":' key={'addChB' + elements.length}  app={this}/> )
		elements.push(<CheckBoxWithTitle type='modBus' x={415} lableX={280} y={455} lableY={453} widthLbl={130} title='Возможность подключения ModBus:' key={'addChB' + elements.length}  app={this}/> )
		return elements
	}
	// -- ЧекБоксы



	// ++ Обработка событий
	// ++ Дропдауны
	onToolTypeChange(event){
		this.onDDChange(event.target.value, 'toolType', 'Acb', 'filterToolType')
	}

	onPolNumbChange(event){
		this.onDDChange(event.target.value, 'polNumb', 'Acb', 'filterPolNumb')
	}

	onPerformanceChange(event){
		this.onDDChange(event.target.value, 'performance', 'Acb', 'filterPerformance')
	}

	onINChange(event){
		this.onDDChange(event.target.value, 'iN', 'Acb', 'filterIN')
	}

	onICUChange(event){
		this.onDDChange(event.target.value, 'iCU', 'Acb', 'filterICU')
	}

	onSizeChange(event){
		this.onDDChange(event.target.value, 'size', 'Acb', 'filterSize')
	}

	onUnHookChange(newValue){

		const [ ...values ] = this.state.filterUnHook
		const index = values.indexOf(newValue.value)

		index === -1 ? values.push(newValue.value) : values.splice(index, 1)

		let itemList = this.getFilteredAcbArray(values, 'unHook')
		this.changeAcbFilterOptions(itemList, values, 'unHook')

		this.setState({
			filterUnHook: values,
			itemList,
		})
	}

	onUnHookDelete(delValue){

		const [ ...values ] = this.state.filterUnHook
		const index = values.indexOf(delValue.value)
		values.splice(index, 1)

		let itemList = this.getFilteredAcbArray(values, 'unHook')
		this.changeAcbFilterOptions(itemList, values, 'unHook')
		this.setState({
			filterUnHook: values,
			itemList,
		})
	}

	onMccbPolNumbChange(event){
		this.onDDChange(event.target.value, 'polNumb', 'Mccb', 'filterMccbPolNumb')
	}

	onMccbINChange(event){
		this.onDDChange(event.target.value, 'iN', 'Mccb', 'filterMccbIN')
	}

	onMccbICUChange(event){
		this.onDDChange(event.target.value, 'iCU', 'Mccb', 'filterMccbICU')
	}

	onMccbSizeChange(event){
		this.onDDChange(event.target.value, 'size', 'Mccb', 'filterMccbSize')
	}

	onMccbUnHookChange(event){
		this.onDDChange(event.target.value, 'unHook', 'Mccb', 'filterMccbUnHook')
	}

	onMccbUnHookDelete(delValue){

		const [ ...values ] = this.state.filterUnHook
		const index = values.indexOf(delValue.value)
		values.splice(index, 1)

		let itemList = this.getFilteredMccbArray(values, 'unHook')
		this.changeMccbFilterOptions(itemList, values, 'unHook')
		this.setState({
			filterMccbUnHook: values,
			itemList,
		})
	}

	onAddDisplayChange(event){
		this.onDDChange(event.target.value, 'display', 'Acb', 'filterAddDisplay')
	}

	onAddProtectChange(event){
		this.onDDChange(event.target.value, 'protect', 'Acb', 'filterAddProtect')
	}

	// -- Дропдауны

	// ++ Чекбоксы
	onEuiChange(event){
		//265px
		let value = event.target.checked

		let itemList = this.getFilteredAcbArray(value, 'eui')
		this.changeAcbFilterOptions(itemList)

		let tableHeight = value ? '245px': '320px'
		let tableTop = value ? '520px' : '430px'
		let bgHeight= value ? '345px' : '255px'

		this.setState({
			itemList,
			eui:value,
			tableHeight,
			tableTop,
			bgHeight,
			...addInputDefault
		})
	}

	onModBusChange(event){
		this.onCheckBoxChange(event.target.value, 'mod_bus', 'Acb', 'modBus')
	}

	onChangeFuncChange(event){
		this.onCheckBoxChange(event.target.value, 'change_func', 'Acb', 'changeFunc')
	}
	// -- Чекбоксы
	// -- Обработка событий

	onCheckBoxChange(value, type, section, stateName){

		let itemList = this['getFiltered' + section + 'Array'](value, type)
		this['change' + section + 'FilterOptions'](itemList)

		this.setState({
			[stateName]: value,
			itemList
		})

	}

	onDDChange(value, type, section, stateName){

		let itemList = this['getFiltered' + section + 'Array'](value, type)
		this['change' + section + 'FilterOptions'](itemList, value, type)

		this.setState({
			[stateName]: value,
			itemList
		})

	}

	getFilteredAcbArray(value = null, type = null){

		let itemList = this.state.acbList
		let toolType =								type === 'toolType' ? value : this.state.filterToolType
		let polNumb =									type === 'polNumb' ? value : this.state.filterPolNumb
		let performance =							type === 'performance' ? value : this.state.filterPerformance
		let iN =											type === 'iN' ? value : this.state.filterIN
		let iCU =											type === 'iCU' ? value : this.state.filterICU
		let size =										type === 'size' ? value : this.state.filterSize
		let unHook =									type === 'unHook' ? value : this.state.filterUnHook
		let protect =									type === 'protect' ? value : this.state.filterAddProtect
		let display =									type === 'display' ? value : this.state.filterAddDisplay
		let mod_bus =									type === 'mod_bus' ? value : this.state.modBus
		let change_func =							type === 'change_func' ? value : this.state.changeFunc
		let eui =											type === 'eui' ? value : this.state.eui

		let mod_bus_to_db = mod_bus ? 'Да' : 'Нет'
		let change_func_to_db = change_func ? 'Да' : 'Нет'

		// Фильтруем по Типy устройства
		if (toolType !== 'Выбрать') 			itemList = itemList.filter(item => item.tool_type === toolType)
		// Фильтруем по количества полюсов
		if (polNumb !== 'Выбрать') 				itemList = itemList.filter(item => item.pol_numb === polNumb)
		// Фильтруем список по исполнени.
		if (performance !== 'Выбрать') 		itemList = itemList.filter(item => item.performance === performance)
		// Фильтруем список по Номинальному току
		if (iN !== 'Выбрать') 						itemList = itemList.filter(item => item.i_n === iN)
		// Фильтруем список по отключающей способности
		if (iCU !== 'Выбрать') 						itemList = itemList.filter(item => item.i_cu === iCU)
		// Фильтруем список типоразмеру
		if (size !== 'Выбрать') 					itemList = itemList.filter(item => item.size === size)
		// Фильтруем список Типу расцепителя
		if (unHook.length) {
			itemList = itemList.filter(item =>{
				return unHook.indexOf(item.unhook_type) !== -1
			})
		}
		// Фильтруем список Типу защиты
		if (protect !== 'Выбрать') 				itemList = itemList.filter(item => item.protection === protect)
		// Фильтруем список Типу дисплея
		if (display !== 'Выбрать') 				itemList = itemList.filter(item => item.display === display)

		if(eui){
			// Фильтруем список по ModBus
			itemList = itemList.filter(item => item.mod_bus === mod_bus_to_db)
			// Фильтруем список Функции Измерения
			itemList = itemList.filter(item => {
				return	item.change_func === change_func_to_db
			})
		}
		return itemList

	}

	changeAcbFilterOptions(itemList, value = null, type = null){

		let toolType =								type === 'toolType' ? value : this.state.filterToolType
		let polNumb =									type === 'polNumb' ? value : this.state.filterPolNumb
		let performance =							type === 'performance' ? value : this.state.filterPerformance
		let iN =											type === 'iN' ? value : this.state.filterIN
		let iCU =											type === 'iCU' ? value : this.state.filterICU
		let size =										type === 'size' ? value : this.state.filterSize
		let unHook =									type === 'unHook' ? value : this.state.filterUnHook
		let protect =									type === 'protect' ? value : this.state.filterAddProtect
		let display =									type === 'display' ? value : this.state.filterAddDisplay

		let toolTypeOptions		 				= this.state.toolTypeOptions
		let polNumbOptions						= this.state.polNumbOptions
		let performanceOptions 				= this.state.performanceOptions
		let iNOptions 								= this.state.iNOptions
		let iCUOptions 								= this.state.iCUOptions
		let sizeOptions 							= this.state.sizeOptions
		let unHookOptions							= this.state.unHookOptions
		let addDisplayOptions					= this.state.addDisplayOptions
		let addProtectOptions					= this.state.addProtectOptions

		//Выбор Типа устройства
		if (toolType === 'Выбрать') toolTypeOptions = this.getOptions(itemList, 'tool_type')
		//Выбор количества полюсов
		if (polNumb === 'Выбрать')	polNumbOptions = this.getOptions(itemList, 'pol_numb')
		//Выбор исполнения
		if (performance === 'Выбрать')	performanceOptions = this.getOptions(itemList, 'performance')
		//Выбор Номинального тока
		if (iN === 'Выбрать')				iNOptions = this.getOptions(itemList, 'i_n')
		//Выбор отключающей способности
		if (iCU === 'Выбрать')			iCUOptions = this.getOptions(itemList, 'i_cu')
		//Выбор Типоразмера
		if (size === 'Выбрать')			sizeOptions = this.getOptions(itemList, 'size')
		//Выбор Типа расцепителя
		if (!unHook.length){
			unHookOptions = this.delDuplicatesFromArray(itemList.map(item => {
				if(item.unhook_type !== '0') return item.unhook_type
				return null
			})).filter(Boolean).map(item=> {return {value:item}})
		}
		//Выбор Дисплея
		if (protect === 'Выбрать')			addProtectOptions = this.getOptions(itemList, 'protection')
		//Выбор Типа защиты
		if (display === 'Выбрать')		addDisplayOptions = this.getOptions(itemList, 'display')
		return this.setState({
			toolTypeOptions,
			polNumbOptions,
			performanceOptions,
			iNOptions,
			iCUOptions,
			sizeOptions,
			unHookOptions,
			addDisplayOptions,
			addProtectOptions,
		})
	}


	getFilteredMccbArray(value = null, type = null){

		let itemList = this.state.mccbList

		let polNumb =									type === 'polNumb' ? value : this.state.filterMccbPolNumb
		let iN =											type === 'iN' ? value : this.state.filterMccbIN
		let iCU =											type === 'iCU' ? value : this.state.filterMccbICU
		let size =										type === 'size' ? value : this.state.filterMccbSize
		let unHook =									type === 'unHook' ? value : this.state.filterMccbUnHook

		// Фильтруем по количества полюсов
		if (polNumb !== 'Выбрать') 				itemList = itemList.filter(item => item.pol_numb === polNumb)
		// Фильтруем список по Номинальному току
		if (iN !== 'Выбрать') 						itemList = itemList.filter(item => item.i_n === iN)
		// Фильтруем список по отключающей способности
		if (iCU !== 'Выбрать') 						itemList = itemList.filter(item => item.i_cu === iCU)
		// Фильтруем список типоразмеру
		if (size !== 'Выбрать') 					itemList = itemList.filter(item => item.size === size[0])
		// Фильтруем список Типу расцепителя
		if (unHook !== 'Выбрать')  				itemList = itemList.filter(item => item.unhook_type === unHook)
		return itemList

	}

	changeMccbFilterOptions(itemList, value = null, type = null){

		let polNumb =									type === 'polNumb' ? value : this.state.filterMccbPolNumb
		let iN =											type === 'iN' ? value : this.state.filterMccbIN
		let iCU =											type === 'iCU' ? value : this.state.filterMccbICU
		let size =										type === 'size' ? value : this.state.filterMccbSize
		let unHook =									type === 'unHook' ? value : this.state.filterMccbUnHook

		let mccbPolNumbOptions							= this.state.mccbPolNumbOptions
		let mccbINOptions 									= this.state.mccbINOptions
		let mccbICUOptions 									= this.state.mccbICUOptions
		let mccbSizeOptions 								= this.state.mccbSizeOptions
		let mccbUnHookOptions 							= this.state.mccbUnHookOptions

		//Выбор количества полюсов
		if (polNumb === 'Выбрать')	mccbPolNumbOptions = this.getOptions(itemList, 'pol_numb')
		//Выбор Номинального тока
		if (iN === 'Выбрать')				mccbINOptions = this.getOptions(itemList, 'i_n')
		//Выбор отключающей способности
		if (iCU === 'Выбрать')			mccbICUOptions = this.getOptions(itemList, 'i_cu')
		//Выбор Типоразмера
		if (size === 'Выбрать')			mccbSizeOptions = this.addCurrent(this.getOptions(itemList, 'size'))
		//Выбор Типа расцепителя
		if (unHook === 'Выбрать')   mccbUnHookOptions = this.getOptions(itemList, 'unhook_type')
		return this.setState({
			mccbPolNumbOptions,
			mccbINOptions,
			mccbICUOptions,
			mccbSizeOptions,
			mccbUnHookOptions
		})
	}


	addCurrent(array){

		array = array.map(item =>{

			switch(item){
				case 'S': item = item + ', 63 A'; break;
				case 'A': item = item + ', 125 A'; break;
				case 'D': item = item + ', 160 A'; break;
				case 'G': item = item + ', 250 A'; break;
				case 'H': item = item + ', 400 A'; break;
				case 'I': item = item + ', 630 A'; break;
				case 'N': item = item + ', 1600 A'; break;
			}

			return item
		})
		return array
	}

	addInfo(){

		let left = 145
		let top = 320
		return (
			<div>
				<span
					style={{top: top+'px', left: left+'px',zIndex:'100'}}
					className={styles.additionInfo}
											 onPointerEnter={() => this.setState({showAdditionVoltInfo: true})}
											 onPointerLeave={() => this.setState({showAdditionVoltInfo: false})}>&#63;</span>
				{this.state.showAdditionVoltInfo
					&& <span
						className={styles.showAdditionInfo}
						style={{top: top+20+'px', left: left-130+'px'}}
					>
						TD — Дисплей, Стандартный набор защит: LSI.
						<br/>
						<br/>
						TY — Дисплей с расширенным функционалом, Расширенный набор защит LSIG,
						Возможность подключения по протоколу ModBus.
						<br/>
						<br/>
						TT — Цветной дисплей с функцией Touchscreen,
						Расширенный набор защит LSIG,
						Возможность подключения по протоколу ModBus, Функция "Измерения"
						<br/>
						<br/>
						W — без расцепителей
				</span>}
			</div>
		)

	}

	// Рендер
	render() {

		let	firstLableStyle = this.state.tabType === 'acb' ? '#fff':'#E6EFF1'
		let	secondLableStyle = this.state.tabType === 'acb' ? '#E6EFF1':'#fff'


		return (
			<div className={styles.cfg}>

				{/*Белый фон и лого*/}
				<div style={{position: 'absolute', margin: '0 auto', backgroundColor: '#fff', width: '10%', height: '80px'}}/>
				<Image
					className={styles.logo}
					blockChangeScale={true}
				/>
				{/*Зеленый фон заголовка*/}
				<div style={{margin: '0 auto', backgroundColor: '#ffcc3f', width: '100%', height: '80px'}}/>
				<div className={styles.title}>Подбор силового автоматического выключателя ARMAT</div>

				{/*Левая часть*/}
				<div style={{position: 'absolute', top: '100px', left: "20px"}}>
        	<span
						onClick={this.acbChosen}
						style={{background: firstLableStyle}}
						className={styles.acbSectionTitle + ' ' + 'activeTab'}>Воздушный автоматичкский выключатель (АСВ)</span>
					<span
						onClick={this.mccbChosen}
						style={{background: secondLableStyle}}
						className={styles.mccbCableTitle + ' ' + 'activeTab'}>Автоматы в литом корпусе (МССВ)</span>
				</div>

				<div>
					{this.state.tabType === 'acb' &&
						<div> {/*Область ACB*/}
							{this.acbDropDown ? this.acbDropDown() : null}
							<div style={{
								position: 'absolute',
								top: '153px',
								left: '20px',
								margin: '0 auto',
								backgroundColor: '#fff',
								width: '440px',
								height: this.state.bgHeight,
								zIndex: '1'
							}}/>

							{this.addInfo ? this.addInfo() : null}

							<CheckBoxWithTitle type='eui' x={230} lableX={40} y={378} lableY={374} widthLbl={180} title='Можно выбрать выключатель по параметрам расцепителя:' key='mainchbox1' app={this}/>
							{this.state.eui && this.euiDropDown ? this.euiDropDown() : null}
							{this.state.eui && this.euiCheckBox ? this.euiCheckBox() : null}

						</div>
					}
					{this.state.tabType === 'mccb' &&

						<div>
							{/*Область MCCB*/}
							{this.mccbDropDown ? this.mccbDropDown() : null}

							<div style={{
								position: 'absolute',
								top: '153px',
								left: '20px',
								margin: '0 auto',
								backgroundColor: '#fff',
								width: '440px',
								height: this.state.bgHeight,
								zIndex: '1'
							}}/>
						</div>
					}
				</div>

				<button
					style={{top: this.state.tabType === 'acb' ?'340px':'285px', left: this.state.tabType === 'acb' ? '280px':'280px', zIndex:'111'}}
					className={styles.ResetButton}
					onClick={this.onClearFiltersClick}
				>Сбросить фильтр</button>

				{/*Спецификация*/}
				<Table
					title='Аксессуары'
					type='NoBucket'
					items={this.state.itemList}
					styles={{width: '440px', height: this.state.tableHeight, top: this.state.tableTop, left: '20px', fontSize: '12px'}}
					onSelect={this.onListItemCheck}
					addBasket={this.addBasket}
					itemInfo={this.state.itemInfo}
					color='#ffcc3f'
				/>

				{/*Середина*/}
				{/*Корзина*/}
				<Table
					title='Корзина'
					type='Bucket'
					items={this.state.specList}
					styles={{width: '440px', height: '500px', top: '100px', left: '480px', fontSize: '12px'}}
					onSelect={this.onListItemCheck}
					onDelete={this.onDelete}
					onChangeQuantity={this.onChangeQuantity}
					color='#ffcc3f'
					// configType='power'
				/>

				{/*Сумма*/}
				<div className={styles.sum}>Сумма: {this.state.summ} руб.</div>

				{/*Предупреждение*/}
				<div style={{position:'absolute', border:'#24BA66 1px solid ', backgroundColor: '#E1EFD8', left:'480px', width: '440px', height: '46px', top:'700px',zIndex:'10'}}/>
				<div className={styles.priceWarn}>Просим обратить Ваше внимание – что
					данная стоимость является оценочной, т.к не учитывает персональные скидки,
					размер которых и вашу финальную стоимость данной продукции Вы можете узнать
					обратившись к вашему менеджеру</div>

				{/*Правая часть*/}
				{/* Артикул и имя */}
				<div className={styles.itemInfoBG}/>
				{this.state.itemInfo && this.state.itemInfo[0] ? (
						<a href={`https://www.iek.ru/products/catalog/?page=detail&article=${this.state.itemInfo[0] && this.state.itemInfo[0].art}`}
						 target="_blank">
						<div className={styles.itemInfo}>
							<div className={styles.itemInfo_Article}>{this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].art}</div>
							<div>{this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].name}</div>
						</div>
					</a>
				) : (
					<div className={styles.itemInfoNoArticle}/>
				)}

				{/* Фото */}
				<Image
					className={styles.itemImg + ' ' +
					(this.state.itemInfo && this.state.itemInfo.length === 0 ? styles.warn : '')}
					url={this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].ImgPng && this.state.itemInfo[0].ImgPng[0].file_ref.uri ? this.state.itemInfo[0].ImgPng[0].file_ref.uri : null}
				/>

				{/* Описание */}
				<div style={{
					position: 'absolute',
					top: '452px',
					left: '940px',
					backgroundColor: '#fff',
					width: '434px',
					height: '232px'
				}}/>
				{this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].Description[0].desc_ru ? (
					<div className={styles.description}>
						{this.state.itemInfo[0].Description[0].desc_ru}
					</div>
				) : this.state.itemInfo && this.state.itemInfo.length === 0 ? (
						<div className={styles.description}>
							На сайте временно веутся технические работы. Некоторые данные могут быть недоступны
						</div>
					)
					: (
					<div className={styles.descriptionEmpty}>
					</div>
				)}


				{/*Кнопки*/}
				{this.getCustomButtons ? this.getCustomButtons() : null}

				{/*Нижняя плашка*/}
				{/* На основной сайт IEK */}
				<div style={{position:'absolute', backgroundColor: '#ffffff', width: '50%', height: '20px', top:'820px'}}/>
				<a  className={styles.homeLink} href={'https://www.iek.ru/'} target="_blank">На основной сайт IEK</a>

				{/* Техническая поддержка */}
				<div style={{position:'absolute', backgroundColor: '#ffcc3f', width: '50%', height: '20px', top:'820px', left: '700px'}}/>
				<a style={{
					position: 'absolute',
					top: '823px',
					left: '415px',
					color: '#3c4e50',
					width: '141px',
					height: '14px'
				}} href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-27</span>

			</div>)
	}

}
export default PowerSwitcherConfigurator;

class DropDown extends React.Component {

	render() {
		const {type, app, x, y, title} = this.props
		let typeCap = app.capitalizeFirstLetter(type)
		return <div>
			<span className={styles.selectLabel} style={{top: y + 'px', left: x + 'px'}}>{title}</span>
			<select
				className={styles.selectBase}
				style={{top: y + 17 + 'px', left: x + 'px'}}
				onChange={app['on' + typeCap + 'Change']}
				value={app.state['filter' + typeCap]}
				disabled={!(app.state[type + 'Options'].length > 1)}
			> {app.state[type + 'Options'].length > 0
				? app.state[type + 'Options'].map((option, index) => {
					return (
						<option value={option} key={index + option}>{option} </option>)
				})
				: <option value="Выбрать">Выбрать</option>
			}
			</select>
		</div>
	}

}

class CheckBoxWithTitle extends React.Component {

	render() {
		const {type, app, x, y, title, lableX, lableY, widthLbl} = this.props
		let typeCap = app.capitalizeFirstLetter(type)

		return <div>
			<label className={styles.modeChk}
						 style={{top: lableY + 'px', left: lableX + 'px', width: widthLbl + 'px', zIndex:'14'}}>{title}</label>
			<input
				style={{top: y + 'px', left: x + 'px', position: 'absolute', zIndex: '10', height:'16px', width:'16px'}}
				type="checkbox"
				checked={app.state[type]}
				onChange={app['on' + typeCap + 'Change']}/>
		</ div>
	}
}






// WEBPACK FOOTER //
// ./src/react/PowerSwitcherConfigurator.jsx